//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Slider from "../Slider/Slider.async";
import SliderItem from "../Slider/SliderItem";
import Modal from "./Modal";
import FormBtn from "../Button/FormBtn";
import Icon from "../Icon/Icon";
import Toggleable from "../../mixins/Toggleable";
import CdnImage from "../Image/CdnImage";

export default {
    name: 'ImageModal',

    components: {Icon, FormBtn, Modal, SliderItem, Slider, CdnImage},

    mixins: [Toggleable],

    props: {

        // The default media index to display
        index: {
            default: null
        },

        // The sources of the images to show
        src: {
            type: [Array, Object],
            default: null
        },

        // States if the media can be downloaded
        downloadable: {
            type: Boolean,
            default: false
        },

        // Whether navigation dots shall be displayed on the preview
        showPagination: {
            type: Boolean,
            default: false
        },

        // Whether a border radius shall be applied on the preview image
        rounded: {
            type: Boolean,
            default: false
        },

        // Number of slides per view (slides visible at the same time on slider's container).
        slidesPerView: {
            type: Number,
            default: 1
        },

        // The background color to use (or true for a slight gray) when the contained image does not fit the aspect ratio
        backgroundColor: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            visibleIndex: this.index,
            items: [],
        }
    },

    computed: {
        imageItems() {
            return Array.isArray(this.src) ? this.src : [this.src];
        }
    },

    watch: {
        index(index) {
            this.visibleIndex = index;
        },

        visibleIndex(value) {
            this.$emit('update:index', value)
        },
    },

    methods: {
        openIndex(index) {
            this.visibleIndex = index;
            this.isActive = true;
        }
    }
}
